import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import withLanguage from "../../../HOC/withLanguage";

function SearchCard({ language, item }) {
  const navigate = useNavigate();
  const navigateHandler = () => {
    if (
      item.type === "shkolle_profesionale") {
      navigate(`/shkollat-e-mesme-profesionale/${item.id}`);
    } else if (item.type === "qender_formimi") {
      navigate(`/formation-centers/${item.id}`);
    } else if (item.type === "konvikt") {
      navigate(`/universities/${item.id}`);
    }
  };

  return item ? (
    <div
      className="shadow-lg p-8 mt-7 bg-gray-100 cursor-pointer"
      key={item.id}
    >
      <h3 className="pt-4 text-2xl font-bold" onClick={navigateHandler}>{item.name}</h3>
      <p className="font-normal pt-4">{item.text}</p>

      <div>
        <Accordion
          sx={{
            boxShadow: "none",
            color: "#DB3222",
            borderBottom: "1px solid #DB3222",
            borderRadius: "initial !important",
            background: "transparent",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#DB3222" }} />}
            sx={{ paddingLeft: "0px", paddingRight: "0px", fontWeight: "600" }}
          >
            {item.type === "shkolle_profesionale" ? language.accordionTitleDegree
              : language.accordionTitleCourse}
          </AccordionSummary>
          <AccordionDetails>
            <ul className="list-disc">
              {!!item.degree_names &&
                item.degree_names.map((item, index) => {
                  return <li key={index}>{item}</li>;
                })}
            </ul>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  ) : null;
}

export default withLanguage(SearchCard, "SearchCard");
